import { render, staticRenderFns } from "./ManagementPage.vue?vue&type=template&id=296e9ae6&scoped=true&"
import script from "./js/management-page.js?vue&type=script&lang=js&"
export * from "./js/management-page.js?vue&type=script&lang=js&"
import style0 from "./ManagementPage.vue?vue&type=style&index=0&id=296e9ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e9ae6",
  null
  
)

export default component.exports